import React, {useEffect} from 'react';
import Collapse, {Panel} from 'rc-collapse';
import {useSelector} from 'react-redux';
import moment from 'moment';
import {basisForCloseAndProlongDeal} from '../../../../../helpers/data-constants';
import {HCheckbox} from '../../../../../validation/HForm';
import {returnEndStr} from '../../../../../helpers/common';
import Big from 'big.js';

const PenaltySelector = ({
                             penalties,
                             dealId,
                             index,
                             selectedPenalties,
                             extensionDate,
                             onPenaltyChange,
                             setSelectedPenalties,
                             setTotalPenaltyAmount,
                             isCalculated
                         }) => {
    const {accessFeatures} = useSelector(({user}) => user);
    const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"];

    useEffect(() => {
        if (extensionDate && moment(extensionDate).isSameOrAfter(moment(), 'day') && !isCalculated) {
            const allPenaltyNumbers = penalties.map(p => p.number);
            const totalAmount = penalties.reduce((sum, p) => sum.plus(p.penalty), new Big(0));

            setSelectedPenalties(prev => ({
                ...prev,
                [dealId]: allPenaltyNumbers
            }));

            setTotalPenaltyAmount(totalAmount);
        }
    }, [extensionDate, penalties, dealId, setSelectedPenalties, setTotalPenaltyAmount]);

    const isPenaltySelectable = (penaltyNumber) => {
        const dealPenalties = selectedPenalties[dealId] || [];
        return penaltyNumber === 1 || dealPenalties.includes(penaltyNumber - 1);
    };

    const isPenaltyUnselectable = (penaltyNumber) => {
        const dealPenalties = selectedPenalties[dealId] || [];
        const maxSelected = dealPenalties.length > 0 ? Math.max(...dealPenalties) : 0;
        return penaltyNumber === maxSelected;
    };

    return (
        <Collapse collapsible="header" defaultActiveKey={[1]}>
            <Panel
                key={1}
                showArrow={true}
                header={<p>{basisForCloseAndProlongDeal.PENALTY}</p>}
                headerClass="block-datacollapse-header prolong-datacollapse-header"
                className="block-datacollapse-container prolong-datacollapse-container"
            >
                {penalties.map(({dateFrom, dateTo, penalty, days, number}, idx) => {
                    const isSelected = (selectedPenalties[dealId] || []).includes(number);
                    const isSelectable = isPenaltySelectable(number);
                    const isUnselectable = isSelected && isPenaltyUnselectable(number);
                    const isPaymentBlocked = extensionDate && moment(extensionDate).isBefore(moment(), 'day');
                    const isDisabled = (!isSelectable && !isUnselectable) || isPaymentBlocked;

                    const label = `${moment(dateFrom).format("DD.MM.YYYY")} - ${moment(dateTo).format("DD.MM.YYYY")} за ${returnEndStr(days)}`;

                    return (
                        <div key={number} className="form-row">
                            {isExtensionThreeImplementaition ? (
                                <HCheckbox
                                    h="true"
                                    className="input"
                                    name={`deals[${index}].penaltiesNumbers[${idx}]`}
                                    id={`penalty-${dealId}-${number}`}
                                    label={label}
                                    checked={isSelected}
                                    onChange={(e) =>
                                        onPenaltyChange(
                                            dealId,
                                            number,
                                            penalty,
                                            e.target.checked,
                                            penalties,
                                            extensionDate
                                        )
                                    }
                                    disabled={isDisabled}
                                />
                            ) : (
                                <span className="checkbox-label penalty-amount">{label}</span>
                            )}
                            <p className="penalty-amount">{penalty.toFixed(2)} руб.</p>
                        </div>
                    );
                })}
            </Panel>
        </Collapse>
    );
};

export default PenaltySelector;
